import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Auth context and common components
import LoadingSpinner from './components/common/LoadingSpinner';
import ErrorBoundary from './components/common/ErrorBoundary';

// Auth context and protected route
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Analytics provider
import { AnalyticsProvider } from './context/AnalyticsContext';

// Lazy loaded components
// Public components
const HomePage = lazy(() => import('./components/public/HomePage'));
const AboutPage = lazy(() => import('./components/public/AboutPage'));
const ServicesPage = lazy(() => import('./components/public/ServicesPage'));
const ContactPage = lazy(() => import('./components/public/ContactPage'));
const ServiceDetailPage = lazy(() => import('./components/public/ServiceDetailPage'));
const RequestServicePage = lazy(() => import('./components/public/RequestServicePage'));

// Admin components
const AdminLayout = lazy(() => import('./components/admin/AdminLayout'));
const Dashboard = lazy(() => import('./components/admin/Dashboard'));
const ServicesManagement = lazy(() => import('./components/admin/ServicesManagement'));
const ServiceRequestsManagement = lazy(() => import('./components/admin/ServiceRequestsManagement'));
const TestimonialsManagement = lazy(() => import('./components/admin/TestimonialsManagement'));
const UserManagement = lazy(() => import('./components/admin/UserManagement'));
const ContactsManagement = lazy(() => import('./components/admin/ContactsManagement'));
const Login = lazy(() => import('./components/auth/Login'));

// App component definition

function App() {
  return (
    <AuthProvider>
      <Router>
        <ErrorBoundary>
          <AnalyticsProvider>
            <Suspense fallback={<LoadingSpinner />}>
            <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/request-service" element={<RequestServicePage />} />
            <Route path="/login" element={<Login />} />

            {/* Admin Routes */}
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="services" element={<ServicesManagement />} />
              <Route path="service-requests" element={<ServiceRequestsManagement />} />
              <Route path="testimonials" element={<TestimonialsManagement />} />
              <Route path="contacts" element={<ContactsManagement />} />
              <Route path="settings" element={<Dashboard />} /> {/* Placeholder until SettingsManagement is created */}
              <Route path="users" element={<UserManagement />} />
            </Route>

            {/* 404 Route */}
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </Suspense>
          </AnalyticsProvider>
        </ErrorBoundary>
      </Router>
    </AuthProvider>
  );
}

export default App;
